import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { toast } from "sonner";
import { TurfTalk } from "@/api/client";
import { RoomWithNews } from "@/components/RoomWithNews";
import { Skeleton } from "@/components/ui-kit";
import { trackRoomJoin, trackRoomLeave } from "@/lib/telemetry";

export default function RoomDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [room, setRoom] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    const joinedAt = Date.now();
    TurfTalk.getRoom(id).then((r) => { setRoom(r.room || r); trackRoomJoin(id); }).catch((e) => setErr(e.message));
    return () => { trackRoomLeave(id, Date.now() - joinedAt); };
  }, [id]);

  const leave = async () => {
    try { await TurfTalk.leaveRoom(id); toast.success("Left room"); navigate("/rooms"); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-6">
      <div className="flex items-center justify-between mb-4">
        <Link to="/rooms" className="inline-flex items-center gap-1.5 text-white/50 hover:text-white text-sm"><ArrowLeft size={16} /> Rooms</Link>
        {room && room.kind !== "official" && (
          <button onClick={leave} data-testid="room-leave" className="inline-flex items-center gap-2 px-3 h-9 rounded-lg tt-panel text-white/70 hover:text-white text-sm"><LogOut size={14} /> Leave</button>
        )}
      </div>
      {err ? <div className="tt-panel rounded-xl p-8 text-center text-white/50">{err}</div>
        : !room ? <Skeleton className="h-[520px]" />
        : <RoomWithNews roomId={id} title={room.name} gameId={room.game_id || null} league={room.league || null} height={560} />}
    </div>
  );
}
